// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"caeaf1e9","540":"7bd44f4a"}[chunkId] + ".chunk.js";
};